import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  toString3dhdjl9yf50de as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source) {
        super();
        this.i2x_1 = source;
      }
      p2w() {
        return this.i2x_1;
      }
      q2w(position) {
        return position < this.p2w().length ? position : -1;
      }
      f2t() {
        var source = this.p2w();
        var cpos = this.r2m_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.r2m_1 = cpos;
          return charToTokenClass(c);
        }
        this.r2m_1 = source.length;
        return 10;
      }
      b2t() {
        var current = this.r2m_1;
        if (current === -1)
          return false;
        var source = this.p2w();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.r2m_1 = current;
          return this.t2w(c);
        }
        this.r2m_1 = current;
        return false;
      }
      s2w() {
        var current = this.r2m_1;
        if (current === -1)
          return current;
        var source = this.p2w();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.r2m_1 = current;
        return current;
      }
      l2t(expected) {
        if (this.r2m_1 === -1) {
          this.u2w(expected);
        }
        var source = this.p2w();
        var cpos = this.r2m_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.r2m_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.u2w(expected);
        }
        this.r2m_1 = -1;
        this.u2w(expected);
      }
      r2t() {
        this.l2t(_Char___init__impl__6a9atx(34));
        var current = this.r2m_1;
        var closingQuote = indexOf(this.p2w(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.d2t();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false ? this.r2m_1 - 1 | 0 : this.r2m_1;
          var s = this.r2m_1 === charSequenceLength(this.p2w()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.p2w(), position));
          var tmp$ret$0 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.n2r(tmp$ret$0, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.p2w(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.p2w(), this.r2m_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.r2m_1 = closingQuote + 1 | 0;
        return substring(this.p2w(), current, closingQuote);
      }
      t2t(keyToMatch, isLenient) {
        var positionSnapshot = this.r2m_1;
        try {
          if (!(this.f2t() === 6))
            return null;
          var firstKey = this.o2t(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.v2w();
          if (!(this.f2t() === 5))
            return null;
          return this.o2t(isLenient);
        }finally {
          this.r2m_1 = positionSnapshot;
          this.v2w();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.e2m_1.e2o_1 ? new (StringJsonLexer())(source) : new (StringJsonLexerWithComments())(source);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
